/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { cssMap as customCssMap, jsx } from '@compiled/react';

const wrapperStyles = customCssMap({
	text: {
		color: 'var(--nav-text-color)',
	},
});

/**
 * Wrapper component for button text content to use CSS variable
 */
export const ButtonTextWrapper: ({ children }: { children: ReactNode }) => JSX.Element = ({
	children,
}: {
	children: ReactNode;
}) => <span css={wrapperStyles.text}>{children}</span>;
